import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import InviteCreateAccess from '@shared/components/organization/invite/InviteCreateAccess';
import MemberPageContent from '@shared/components/organization/member/MemberPageContent';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgMembersPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isExpiredOrg, membership, isLoading } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;
    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:organization.member.orgTitle', { value: currentOrg?.name })}
                description={t('common:organization.member.description')}
                items={items}>
                {currentOrg && !isExpiredOrg && currentOrg.id && membership && (
                    <InviteCreateAccess myRole={extractRoleProperties(membership)} organizationId={currentOrg.id} />
                )}
            </PageHeader>

            <MemberPageContent />
        </OrgPageTemplate>
    );
}
